<div (click)="offCanvasCart.open()" class="cart-thumb-container position-relative">
  <vl-icon class="!flex cursor-pointer" size="3xl" pack="font-awesome-solid" icon="shopping-cart" status="dark">
    <vl-badge class="absolute font-medium -top-2 -right-2 text-base" *ngIf="cart?.cart_offers?.length" status="primary" size="xs">{{ cart.cart_offers.length }}</vl-badge>
  </vl-icon>
</div>

<vg-offcanvas #offCanvasCart>
  <vg-offcanvas-header class="flex">
    <h5 i18n="@@header.my_cart">My Cart</h5>

    <vl-button class="ml-auto" status="dark" (onClick)="flush()" *ngIf="cart?.cart_offers?.length && !cartRouting">
      <vl-icon status="light" size="lg" icon="eraser" pack="font-awesome-solid"></vl-icon>
      <span i18n="@@header.empty_my_cart" class="hidden sm:block ml-2">Empty my cart</span>
    </vl-button>
  </vg-offcanvas-header>
  <vg-offcanvas-body>

    <div class="flex flex-col gap-4" *ngIf="!cart">
      <div class="flex flex-col gap-4">
        <div class="pb-4 border-b border-secondary/25" *ngFor="let i of [].constructor(2)">
          <div class="flex gap-4">
            <div class="relative float-left flex flex-col gap-2">
              <skeleton type="image" class="rounded !w-[100px] !h-[135px]"></skeleton>

              <div class="flex justify-between items-baseline">
                <skeleton class="max-w-[50px]"></skeleton>
                <skeleton class="max-w-[20px]"></skeleton>
              </div>
            </div>
            <div class="float-right w-full flex flex-col gap-1">
              <skeleton class="!h-20"></skeleton>
              <ng-container *ngFor="let x of [].constructor(4)" [ngTemplateOutlet]="itemTemplate"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="cart">
      <ng-container *ngIf="!cart?.cart_offers?.length">
        <div class="text-center items-center flex flex-col gap-4">
          <h3 class="text-xl" i18n="@@header.cart_is_empty">Your cart is empty.</h3>

          <vl-icon status="dark" size="2xl" pack="font-awesome-solid" icon="shopping-cart"></vl-icon>
        </div>
      </ng-container>

      <div class="flex flex-col gap-4" *ngIf="cart?.cart_offers?.length">
        <div class="pb-4 border-b border-secondary/25" *ngFor="let cartOffer of cart.cart_offers; let isFirst = first">
          <div class="flex gap-4">
            <div class="relative float-left flex flex-col gap-2">
              <div class="relative">
                @if(cartOffer?.representation?.product?.offerLogo) {
                <div class="relative">
                  <div class="bg-[#000] absolute z-10 w-full top-full mask-linear-top h-[25px]"></div>
                  <vg-image [skeleton]="false" class="!absolute_ z-10" imgClass="!rounded-b-none" [image]="cartOffer?.representation?.product?.offerLogo | SafeImageLoader | async"></vg-image>
                </div>
                }

                <product-cover [logo]="cartOffer?.representation?.product?.productLogo" [background]="cartOffer?.representation?.product?.productImageNoLogo" [hovering]="false" [mini]="true" [logoPosition]="cartOffer?.representation?.product?.coverLogoPosition"></product-cover>
                <!-- <vg-image class="rounded" [image]="cartOffer?.representation?.product?.productImage | SafeImageLoader | async"></vg-image>-->

                <!-- <vg-image [skeleton]="false" class="filter-shadow !absolute !w-[80%] z-10 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" [skeleton]="false" [image]="cartOffer?.representation?.product?.productLogo | SafeImageLoader | async"></vg-image>
                <vg-image class="rounded" [image]="cartOffer?.representation?.product?.productImageNoLogo | SafeImageLoader | async"></vg-image> -->
              </div>

              <div class="flex justify-between items-baseline _items-center">
                <div class="flex flex-col">
                  <span *ngIf="cartOffer?.pricing?.total_no_promotion?.amount != cartOffer?.pricing?.total?.amount" class="line-through text-secondary text-xs">{{ cartOffer?.pricing?.total_no_promotion?.format }}</span>
                  <span class="text-center text-primary text-sm max-w-[80px] break-words">{{cartOffer?.pricing?.total?.format}}</span>
                </div>
                <vl-icon *ngIf="!isDeletedCartOffer(cartOffer._id) && !cartRouting" class="cursor-pointer" (click)="deleteCartOffer(cartOffer)" status="primary" icon="trash" pack="font-awesome-solid"></vl-icon>
                <vl-spinner-container class="w-[20px]" status="primary" size="xs" *ngIf="isDeletedCartOffer(cartOffer._id)"></vl-spinner-container>
              </div>
            </div>
            <div class="float-right flex flex-col gap-2">
              <div class="flex gap-1">
                <span class="text-base">
                  @if(cartOffer?.quantity?.parameters?.choice_value?.value > 1) {
                  <ng-container>{{ cartOffer?.quantity?.parameters?.choice_value?.value }} x </ng-container>
                  }

                  {{cartOffer?.representation?.product?.offer}}
                </span>
              </div>

              <span *ngIf="cartOffer.renewal" class="text-sm text-success font-bold flex">
                <ng-container i18n="@@header.rental_renew">Rental renew</ng-container>
                #{{ cartOffer.renewal.friendlyId }}
                <ng-container *ngIf="cartOffer.renewal.customName"> - {{ cartOffer.renewal.customName }}</ng-container>
              </span>

              <div class="flex flex-col gap-1">
                <ng-container *ngFor="let capacity of cartOffer?.representation?.offer?.capacities">
                  <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{value: capacity}"></ng-container>
                </ng-container>

                <ng-container *ngFor="let option of cartOffer?.representation?.offer?.options">
                  <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{value: option}"></ng-container>
                </ng-container>

                @if(cartOffer.representation?.offer?.providerDatacenterCompanyPool) {
                <ng-container i18n-context.label [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{label: 'Hosting Location', value: cartOffer.representation.offer.providerDatacenterCompanyPool, badge: cartOffer.representation.offer.providerDatacenterCompanyPool?.outOfStock ? { status: 'danger', text: 'Out of stock'} : null }"></ng-container>
                }
              </div>

              @if(cartOffer?.representation?.preorder) {
              <div class="flex gap-2 text-sm items-center flex-wrap ">
                <vl-badge status="success" size="xs" i18n="@@header.pre_order">Pre-order</vl-badge>
                <span class="text-secondary self-center text-xs"><ng-container i18n="@@header.delivery_date">Delivery date:</ng-container> {{ cartOffer?.representation?.preorder_delivery_at | dateTz:false }}</span>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </ng-container>

  </vg-offcanvas-body>
  <vg-offcanvas-footer *ngIf="cart?.cart_offers?.length">

    <div class="flex flex-col gap-2">
      <div class="flex justify-center space-x-1 text-lg items-center">
        <span i18n="@@header.total">Total:</span>
        <span *ngIf="cart?.pricing?.total?.amount != cart?.pricing?.total_no_promotion?.amount" class="line-through text-secondary text-sm">{{ cart?.pricing?.total_no_promotion?.format }}</span>
        <span class="text-primary flex items-center">{{ cart?.pricing?.total?.format }}</span>
      </div>

      <vl-button *ngIf="!cartRouting" class="mx-auto" (onClick)="checkout()" status="primary">
        <vl-icon status="light" pack="font-awesome-solid" icon="shopping-cart" class="mr-2"></vl-icon>
        <span i18n="@@header.checkout">Checkout</span>
      </vl-button>
    </div>

  </vg-offcanvas-footer>
</vg-offcanvas>

<ng-template #itemTemplate let-value="value" let-label="label">
  <div *ngIf="!value" class="flex space-x-2 text-sm items-center">
    <skeleton class="max-w-[100px]"></skeleton>
    <skeleton class="max-w-[30px]"></skeleton>
  </div>

  <div *ngIf="value" class="flex space-x-1 text-sm items-center flex-wrap">
    <i *ngIf="value?.icon" [ngClass]="value?.icon" class="w-[15px] mr-1"></i>
    <span *ngIf="label">{{ label }} : </span>
    <span class="capitalize">{{ value.name }}</span>

    @if(value.value > 0) {
    <div [ngSwitch]="value.unit">
      <span *ngSwitchCase="'GB'">
        : {{ value.value | gigabyte }}
      </span>
      <span *ngSwitchCase="'slot(s)'">
        : {{ value.value }}
      </span>
      <span *ngSwitchDefault>
        : {{ value.value }} {{ value.unit }}
      </span>
    </div>
    }
  </div>
</ng-template>